import Product from "./Product";
import useFifplFunding from "../utils/useFifplFunding"

export default function Fifpl({ product }){

    const { refund } = useFifplFunding()

    return product &&

        <Product product={product}>

            <div className="apply-option-title">
                <span>FIFPL</span>
            </div>

            <div className="apply-option-row">
                <span>Jusqu'à {refund}€ de remboursé après votre formation</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Dossier de prise en charge prêt à déposer sur votre compte FIFPL</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Accès immédiat</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Avance de frais : Vous réglez les frais initiaux et serez remboursé par le FIFPL par la suite.</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>3 mois à compter de la date d'achat pour terminer la formation</span>
            </div>
            
        </Product>
}